export default __webpack_public_path__ + "static/media/Frame 13.01ddbd77.svg";